import React, { useState, useEffect, useRef } from 'react';

const MainHistoryBlock = () => {
  const [appear, setAppear] = useState(false);

  const historyRef = useRef();

  const handleScroll = () => {
    var top = window.pageYOffset;

    var introOffset;
    if (window.innerWidth < 450)
      introOffset = historyRef.current.offsetTop - window.innerHeight + 320;
    else
      introOffset = historyRef.current.offsetTop - window.innerHeight + 220;
    
    if (top >= introOffset) setAppear(true);
    else setAppear(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div ref={historyRef} className='row main-history'>
      <div className='col-md-6 main-history-text'>
        <div className='overflow-hide'>
          <h2 className={appear ? 'h2-appear' : 'hide-btn'}>
            Established in 1886 <br />
            We are Boss
          </h2>
        </div>
        <p className={appear ? 'h2-appear' : 'hide'}>
          On May 8, 1886, Dr. John Pemberton sold the first glass of Coca-Cola
          at Jacobs' Pharmacy in downtown Atlanta. Serving nine drinks per day
          in its first year, Coca-Cola was new refreshment in its beginning. See
          the story here of how it all began.
        </p>
        {/* <button>Our Story</button> */}
      </div>

      <div
        className={
          appear
            ? 'col-md-6 main-history-image'
            : 'col-md-6 main-history-image hide'
        }
      ></div>
    </div>
  );
};

export default MainHistoryBlock;
